<template>

    <div v-if="!isLoading('user')">

        <div v-if="isActive">
        
            <app-sidebar />

            <div class="main-wrapper">

                <app-header />

                <div class="main">

                    <router-view />

                </div>
            </div>

        </div>

        <div v-else>

            <signin-component />

        </div>
    </div>

    <div class="vh-splashscreen"
        v-else>
        <img class="vh-splashscreen-logo" :src="'/assets/image/splash-logo.png'">
    </div>

</template>

<script>
import { mapGetters } from 'vuex';

import AppSidebar from '@/views/layouts/sidebar';
import AppHeader from '@/views/layouts/header';

import SigninComponent from '@/views/auth/signin';

export default
{
  name: 'App',

  components:
  {
      AppSidebar,
      AppHeader,
      
      SigninComponent,
  },

  computed:
  {
      ...mapGetters({
          isActive: 'auth/isActive',
          isLoading: 'auth/isLoading',
      }),

      appLogo()
      {
          return process.env.VUE_APP_LOGO;
      },

      appVersion()
      {
          return process.env.VUE_APP_TITLE
      }
  }

}
</script>

<style lang="scss">
  @import "./scss/app";
</style>

